import React, { useState } from 'react';
import quoteOptionsData from '../../../data/quoteOptionsData.json';
import { useDispatch, useSelector } from 'react-redux';
import { addValueAction } from '../../reduxstore/actions/quoteActions';
import { PlusIcon } from '@heroicons/react/24/outline';

const AddInformationDialogBox = ({
  isOpen,
  onClose,
  title,
  children,
  heading,
  type,
}) => {
  const dispatch = useDispatch();
  const { value } = useSelector((state) =>
    state.quoteReducer.quote?.[type].data.find(
      (item) => item.heading === heading,
    ),
  );
  const [customOption, setCustomOption] = useState('');
  const options =
    quoteOptionsData[heading].sort((a, b) => a.localeCompare(b)) || [];
  const alreadySelectedOptions = options
    .filter((option) => value.includes(option))
    .sort((a, b) => a.localeCompare(b));
  const notSelectedOptions = options
    .filter((option) => !value.includes(option))
    .sort((a, b) => a.localeCompare(b));

  const handleOptionClick = (option) => {
    dispatch(addValueAction(type, heading, option));
  };

  const handleAddCustomOption = () => {
    dispatch(addValueAction(type, heading, customOption));
    setCustomOption('');
  };

  return (
    <>
      <div className="z-50 overflow-auto flex items-center justify-center max-w-[373px]">
        <div className="z-50 bg-[#D9D9D9] rounded-2xl w-80">
          <div className="p-2 pt-1 grid grid-cols-2 overflow-hidden">
            <input
              type="text"
              name="customOption"
              id="customOption"
              className="relative m-1 px-2 py-1 bg-white rounded-xl hover:cursor-pointer hover:ring-1 hover:ring-black  hover:ring-inset text-[13.33px] text-center font-normal overflow-hidden"
              value={customOption}
              onChange={(e) => setCustomOption(e.target.value)}
              placeholder="type"
            />
            {customOption && (
              <PlusIcon
                className="absolute top-3.5 block h-4 w-4 hover:cursor-pointer"
                aria-hidden="true"
                style={{ left: '136px' }}
                onClick={() => handleAddCustomOption()}
              />
            )}
            {alreadySelectedOptions.map((option, index) => (
              <div
                key={index}
                className="m-1 px-2 py-1 rounded-xl text-[13.33px] text-center font-normal overflow-hidden bg-blue-400 cursor-default"
                onClick={() => {
                  if (!value.includes(option)) {
                    handleOptionClick(option);
                  }
                }}
              >
                {option}
              </div>
            ))}
            {notSelectedOptions.map((option, index) => (
              <div
                key={index}
                className="m-1 px-2 py-1 rounded-xl text-[13.33px] text-center font-normal overflow-hidden
                                            bg-white hover:cursor-pointer hover:ring-1 hover:ring-black hover:ring-inset"
                onClick={() => {
                  if (!value.includes(option)) {
                    handleOptionClick(option);
                  }
                }}
              >
                {option}
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default AddInformationDialogBox;
